import React, {useState} from 'react';
import './App.css';
import store from "./store";

import {
    initDivision,
    initEdges,
    initNodes,
    initPapers,
    initPaperEdges,
    setEdgesTension,
    initScale, setHalfSelectedEdges, setSelectedPapers,
} from "./store/actions";

import nodesDataList from "./data/nodeData.json";
import edgesData from './data/edgesTotal.json';
import paperEdgesData from './data/edgesData.json';
import paperData from './data/PapersInfo.json';
import {Division} from "./data/Division";


import {generateNodesData, getBezierEdgesParseByEdgeList, getInitialSelectedPapers} from './utils';


import ClusterLineCon from "./components/ClusterLine/container";
import NodesCon from "./components/Nodes/container";
import EdgesCon from "./components/Edges/container";
import PapersCon from "./components/Papers/container";
import SwitchTypeCon from "./components/SwitchType/container"
import SliderCon from "./components/Slider/container"
import _ from "lodash";

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}


function App() {
    let {height, width} = getWindowDimensions();
    const [wh, setWh] = useState({height, width});
    const bh = height, bw = width;
    if (width > 3840 && height > 2016) {
        width = 3840
        height = 2016
    }

    if (width * 2016 > 3840 * height) {
        width = (3840 / 2016) * height;
    } else {
        height = width / (3840 / 2106);
    }

    const scale = width / 3840;

    store.dispatch(setEdgesTension(80))
    let nodesData = generateNodesData(Division, nodesDataList, height * 0.03, height * 0.85, 1, scale)
    const eD = Array.from(new Set(edgesData))
    let edgesParse = getBezierEdgesParseByEdgeList(nodesData, eD, store.getState().EdgesData.EdgesType, {
            height,
            width
        },
        store.getState().EdgesData.EdgesTension / 100);

    //dispatch data
    store.dispatch(initDivision(Division));
    store.dispatch(initScale(scale));
    store.dispatch(initNodes(nodesData));
    store.dispatch(initEdges(edgesParse));
    store.dispatch(initPapers(paperData))
    store.dispatch(setHalfSelectedEdges(eD))
    store.dispatch(initPaperEdges(paperEdgesData))
    store.dispatch(setSelectedPapers(getInitialSelectedPapers()))


    const handleResize = _.debounce(() => {
        let {height, width} = getWindowDimensions();
        if (setWh)
            setWh(() => {
                return {height, width}
            })
    }, 100)


    window.addEventListener('resize', handleResize)

    return (
        <div className="body"
             style={{
                 height: bh,
                 width: bw,
             }}>

            <div
                className="BGDiv" style={{
                height: height,
                width: width,
                marginLeft: (bw - width) / 2,
            }}>
                <div
                    id="g"
                    className="header"
                    style={{
                        fontSize: 30 * scale,
                    }}>
                    <div
                        style={
                            {
                                fontWeight: 400,
                                color: "#AAA",
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%,-50%)'
                            }
                        }>A Tool for Exploring Urban Visual Analytics Studies
                    </div>
                    <div style={
                        {
                            position: 'relative',
                            float: "right",
                            paddingLeft: '3%',
                            top: '50%',
                            transform: 'translate(-10%,-50%)'
                        }
                    }>
                        <SwitchTypeCon dimension={{height, width}}/>
                    </div>
                    <div style={
                        {
                            position: 'relative',
                            float: "right",
                            top: '50%',
                            transform: 'translate(0,-50%)',
                            width: '20%',
                        }
                    }>
                        <SliderCon dimension={{height, width}}/>
                    </div>
                </div>
                <svg
                    id="svg"
                    width='75%'
                    height='94%'
                    style={
                        {
                            float: "left"
                        }
                    }
                >
                    <ClusterLineCon dimension={{height, width}}/>
                    <EdgesCon scale={scale}/>
                    <NodesCon scale={scale}/>
                </svg>
                <PapersCon scale={scale} rightDis={(bw - width) / 2} bh={bh}/>
            </div>
        </div>
    );
}

export default App;
